import { Sites } from '@ps/platform-message-framework/common/Sites';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import PlaceOfBirthFieldsDE from '../PlaceOfBirthFieldsDE/PlaceOfBirthFieldsDE';
import PlaceOfBirthFieldsFR from '../PlaceOfBirthFieldsFR/PlaceOfBirthFieldsFR';
import PlaceOfBirthFieldsIT from '../PlaceOfBirthFieldsIT/PlaceOfBirthFieldsIT';

const PlaceOfBirthFields: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);

  switch (site) {
    case Sites.FRA:
      return <PlaceOfBirthFieldsFR />;
    case Sites.ITA:
      return <PlaceOfBirthFieldsIT />;
    case Sites.DE:
      return <PlaceOfBirthFieldsDE />;
    default:
      return null;
  }
};

export default PlaceOfBirthFields;
